import { InjectionToken } from '@angular/core';

export const AUTH_INFO_PROVIDER = new InjectionToken<'CIP' | 'AppService' | 'None'>('Auth provider info', {
    factory: () => 'None' as const
});
